export const CHUNK_RELOAD_KEY = 'murakami-chunk-reload';

export function isChunkLoadError(error) {
	const message = typeof error?.message === 'string' ? error.message : '';

	return error?.name === 'ChunkLoadError' || (message.includes('Loading chunk') && message.includes('failed'));
}
